import React, { useEffect } from 'react';
import Icon from './icons';
import { ATV_LOGO, ROUM_LOGO, brandLabel } from '../brand';
import { officeOf, portalOrigin } from './types';
import { getPerson } from './collect';
import type { Collect, CoCard, Item, Project } from './types';

interface Props {
  p: Project;
  collect: Collect;
  refId: string;
  onClose: () => void;
}

function Card({ it }: { it: Item }) {
  return (
    <div className="pp2-card">
      <div className="pp2-tt"><b>{it.title}</b>{it.required ? <span className="pp2-req">필수</span> : null}</div>
      {it.desc ? <div className="pp2-ds">{it.desc}</div> : null}
      {(it.links.length || it.files.length) ? (
        <div>
          {it.links.map((l, k) => <span className="pp2-gl" key={'l' + k}>🔗 {l.name || '사이트 바로가기'}</span>)}
          {it.files.map((f, k) => <span className="pp2-gl" key={'f' + k}>📎 {f.name || '가이드 파일'}</span>)}
        </div>
      ) : null}
      {it.type === 'file' ? (
        <button className="pp2-up" disabled>⬆ 파일 선택 및 제출</button>
      ) : it.type === 'text_long' ? (
        <div className="pp2-row">
          <textarea className="pp2-in" placeholder="내용을 입력하세요..." readOnly rows={3} />
          <button className="pp2-sb" disabled>제출</button>
        </div>
      ) : it.type === 'radio' || it.type === 'checkbox' ? (
        <div>
          {(it.options && it.options.length ? it.options : ['선택지 1', '선택지 2']).map((o, k) => (
            <div className="pp2-opt" key={k}><span className={it.type === 'radio' ? 'pp2-dot' : 'pp2-box'} />{o}</div>
          ))}
        </div>
      ) : (
        <div className="pp2-row">
          <input className="pp2-in" placeholder="입력하세요..." readOnly />
          <button className="pp2-sb" disabled>제출</button>
        </div>
      )}
    </div>
  );
}

export default function PortalPreview({ p, collect, refId, onClose }: Props) {
  useEffect(() => {
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [onClose]);

  const card = getPerson(collect, refId);
  const url = card.collectProjectId
    ? portalOrigin() + '/api/portal/' + card.collectProjectId + '/share'
    : '(전송하면 실제 포털 링크가 생성됩니다)';
  const mineCos: CoCard[] = collect.cos.filter((co) => co.rep === refId);
  const role = refId === 'gp' ? 'GP' : 'LP';

  return (
    <div id="portal-ov">
      <div className="povbar">
        <span>🚀 {brandLabel(officeOf(p))} · 자료 제출 포탈 (미리보기)</span>
        <button className="povx" onClick={onClose}><Icon n="x" /> 닫기</button>
      </div>
      <div className="povscroll">
        <div className="pp2-wrap">
          <div className="pp2-brand"><img src={officeOf(p) === 'atv' ? ATV_LOGO : ROUM_LOGO} alt={brandLabel(officeOf(p))} style={{ height: 26, width: 'auto', display: 'block' }} /></div>
          <div className="pp2-org">{p.org}</div>
          <div className="pp2-mod">벤처기업 확인 (투자형) {card.name || role}님</div>
          <div className="pp2-url">{url}</div>

          <div className="pp2-sec">📋 1. {role} {card.name || ''}님 개인 — 제출해 주세요 <span className="cnt">({card.items.length})</span></div>
          {card.items.length
            ? card.items.map((it) => <Card it={it} key={it.id} />)
            : <div className="pp2-card"><div className="pp2-ds">개인 요청 항목이 없습니다.</div></div>}

          {mineCos.map((co, k) => (
            <React.Fragment key={co.id}>
              <div className="pp2-sec">🏢 {k + 2}. {co.name || co.bizno || '(법인)'} 법인 — 제출해 주세요 <span className="cnt">({co.items.length})</span></div>
              {co.items.length
                ? co.items.map((it) => <Card it={it} key={it.id} />)
                : <div className="pp2-card"><div className="pp2-ds">법인 요청 항목이 없습니다.</div></div>}
            </React.Fragment>
          ))}

          <div className="pp2-ft">미리보기 화면입니다 · 전송하면 위 링크의 실제 고객 포털에서 입력·제출이 활성화됩니다.</div>
        </div>
      </div>
    </div>
  );
}
